import { isEmpty } from '../../utils/CDPUtils'
import { REGEX_NUMBERIC, REGEX_ALPHA_NUMBERIC } from '../../utils/Constants'
export const errorMessages = {
    headError: '入力エラーがあります。再度お確かめの上、ご入力ください。',
    nameKanji: '※お名前は必須項目です',
    nameKana: '※フリガナは必須項目です',
    onlyKana: '※全角カタカナのみです',
    nameLenght: '※無効な長さです',
    'nameKanji.kanaError': 'お名前を確認して下さい',
    'nameKana.kanaError': 'フリガナを確認して下さい',
    age: '※年齢は必須項目です',
    age1: '※年齢をご確認ください',
    ageInvalid: '※入力形式が間違っている部分があります',
    dob: '生年月日は必須項目です',
    year: '※生年月日（年）は必須項目です',
    month: '※生年月日（月）は必須項目です',
    day: '※生年月日（日）は必須項目です',
    mailId: '※メールアドレスは必須項目です',
    mailPattern: '※入力形式が間違っている部分があります',
    confirmMailId: '※メールアドレス（確認用）は必須項目です',
    phoneNumber: '※電話番号は必須項目です',
    'phoneNumber.spaceError': '入力形式が間違っている部分があります',
    phoneNumberInvalid: '※入力形式が間違っている部分があります',
    'phoneNumber.lengthError': '入力形式が間違っている部分があります',
    finalEduBgTypes: '※最終学歴は必須項目です',
    workExperienceTypes: '※職歴は必須項目です',
    changeOccupationTypes: '※転職回数は必須項目です',
    nowOccupationTypes: '※現在の就業状況は必須項目です',
    formWhereComeFrom: '※訪問したきっかけは必須項目です',
    whereCDPMemoTypes1: '※CDP受講希望地は必須項目です',
    whereCDPMemoTypes2: '※CDP受講希望地は必須項目です',
    checkMailId: '※「メールアドレス」と「メールアドレス（確認用）」が一致していません',
    headErrorMssg: '入力内容に不備があります。',
    kanaKaniFormatErrorMsg: '★全角カタカナのみです',
    overCharLimitKanji: '★15文字以下です',
    overCharLimitKana: '★15文字以下です',
    invalidFormatKanji: '★全角文字のみです',
    invalidFormatKana: '★全角カタカナのみです',
    FormatKana: '★全角カタカナのみです',
    NotFullWidthKanji02: '★全角文字のみです',
    insufficientInputZipCode3: '★3文字です',
    insufficientInputZipCode4: '★4文字です',
    insufficientInput: '★7文字です',
    invalidChar: '★半角数字のみ',
    insufficientInputs: '★10文字以上11文字以下です',
    birthYear: '★4文字以下です',
    isOverLimit: '★12文字以下です',
    invalidCharZipCode: '★半角数字のみです',
    invalidFormatPhoneNumber: '★入力形式が間違っている部分があります',
    invalidCharPhoneNumber: '★半角数字のみです,',
    invalidFormatEmail: '★入力形式が間違っている部分があります',
    isEmailLimit: '★30文字以下です',
    isF2FRemarksLimit: '★500文字以下です',
    IfEmptyCertificate: '★必須項目が入力されておりません',
    lengthCertificate: '★10文字です',
    remarkBlankCheck: '★必須項目が入力されておりません',
    formatCertificate: '★半角英数字のみです',
    Address1IfEmpty: '★必須項目が入力されておりません',
    Address2IfEmpty: '★必須項目が入力されておりません',
    invalidIfEmpty: '★必須項目が入力されておりません',
    birthIfEmpty: '★必須項目が入力されておりません',
    birthYearLimit: '★4文字以下です',
    kanjiIfEmpty: '★必須項目が入力されておりません',
    kanaIfEmpty: '★必須項目が入力されておりません',
    fullWidthcharOrAlphabet: '★全角文字のみです',
    fullWidthcharOrAlphabetKanji: '★★全角文字のみです',
    fullWidthcharOrAlphabetKana: '★★全角文字のみです',
    halfWidthchar: '★半角数字のみです',
    outOfRange: '★入力形式が間違っている部分があります',
    overLimited: '★10文字以下です',
    overLimitedKanji: '★10文字以下です',
    overLimitedkana: '★10文字以下です',
    isRelationLimit: '★20文字以下です',
    IfNotHalfWidthNumberTelephone: '★入力形式が間違っている部分があります',
    isOverLimitTelephoneLength: '★14文字以下です',
    IfNoEmail2: '★入力形式が間違っている部分があります',
    isOverLimitEmail2: '★30文字以下です',
    Address1Range: '★30文字以下です',
    Address2Range: '★30文字以下です',
    Address3Range: '★30文字以下です',
    isOverLimits: '★50文字以下です',
    AddressLimit: '★30文字以下です',
    NotFullWidthKanji: '★全角文字のみです',
    isOverLimitKanji: '★10文字以下です',
    isOverLimitKana: '★10文字以下です',
    InvalidInputKana: '★全角文字のみです',
    InputKana02: '★全角カタカナのみです',
    LimitKana02: '★10文字以下です',
    birthlimit: '★選択された日付は無効です、正しい日付を選択してください',
    Address1Format: '★全角文字のみです',
    Address2Format: '★全角文字のみです',
    Address3Format: '★全角文字のみです',
    IfNotHalfWidthNumber: '★入力形式が間違っている部分があります',
    ifNotHalfWidthNumber: '★入力形式が間違っている部分があります',
    telephoneLimit: '★14文字以下です',
    TelophoneIfEmpty: '★必須項目が入力されておりません',
    IfEmptyEmail: '★必須項目が入力されておりません',
    isEmailFormat: '★入力形式が間違っている部分があります',
    isRemarkLimit: '★2000文字以下です',
    RelationNotFullWidth: '★全角文字のみです',
    radio: '【ご注意ください】',
    radioButtonmssg: '【ご注意ください】契約内容のご確認、住所変更など各種お手続きや保険金・給付金のご請求についてはご契約者さま専用のお問い合わせ先をご利用ください。',
    // merge duplicates
    ifEmpty: '★必須項目が入力されておりません',
    charLimit500: '★500文字以下です',
    charLimit60: '★60文字以下です',
    charLimit50: '★50文字以下です',
    charLimit30: '★30文字以下です',
    charLimit15: '★15文字以下です',
    charLimit13: '★13文字以下です',
    charLimit3: '★3文字です',
    charLimit4: '★4文字です',
    invalidInput: '★入力形式が間違っている部分があります',
    invalidFullWidth: '★全角文字のみです',
    invalidKana: '★全角カタカナのみです',
    // pamphlet custom validation
    pamphletInvalidKana: '★全角カタカナです',
    pamphletInvalidKanaFirst: '★（名）全角カタカナです',
    pamphletInvalidKanaLast: '★（姓）全角カタカナです',
    pamphletInvalidKanji: '★全角文字のみです',
    pamphletInvalidKanjiFirst: '★（名）全角文字のみです',
    pamphletInvalidKanjiLast: '★（姓）全角文字のみです'
}

export const requestFieldsArray = [{ fieldName: 'nameKanji', allowSpace: false },
{ fieldName: 'nameKana', allowSpace: false },
{ fieldName: 'age', maxLength: 2, fieldType: 'numeric', allowSpace: false },
{ fieldName: 'dobyear', required: false },
{ fieldName: 'dobmonth', required: false },
{ fieldName: 'dobday', required: false, fieldArray: ['dobyear', 'dobmonth', 'dobday'] },
{ fieldName: 'policyNumber', minlength: 10, maxLength: 10, fieldType: 'alphanumeric', allowSpace: false, required: true, checkboxField: 'policyUnknown' },
{ fieldName: 'mailId', allowSpace: true },
{ fieldName: 'confirmMailId', allowSpace: true },
{ fieldName: 'phoneNumber', minlength: 10, maxLength: 11, fieldType: 'numeric', allowSpace: false },
{ fieldName: 'finalEduBkgTypes' },
{ fieldName: 'workExperienceTypes' },
{ fieldName: 'changeOccupationTypes' },
{ fieldName: 'nowOccupationTypes' },
{ fieldName: 'whereCDPMemoTypes1' },
{ fieldName: 'whereCDPMemoTypes2' }
]

export function validateForm (values) {
    let valid = false
    let field
    for (let i = 0; i < requestFieldsArray.length; i++) {
        field = requestFieldsArray[i]
        // const checkboxField = field.checkboxField
        // const checkBoxValue = (event.target.name === checkboxField) ? getCheckBoxValue(event, checkboxField) : values[field.checkboxField]
        // const performValidation = validateFieldWithCheckBox(field, checkBoxValue)
        if (isEmpty(values[field.fieldName])) {
            const fieldErrors = getFieldError(values[field.fieldName], field)
            valid = isEmpty(fieldErrors)
            if (!valid) {
                break
            }
        } else if (field.required || field.required === undefined) {
            valid = false
            break
        }
    }
    return valid
}
export function validateFieldValue (fieldName, fieldValue, values, errors) {
    const validate = false
    let errorMessage = ''
    const field = requestFieldsArray.find(field => field.fieldName === fieldName)
    delete errors[fieldName]
    if (validate) {
        let isValid = true
        if (isEmpty(fieldValue)) {
            errorMessage = errorMessages[fieldName]
            isValid = false
        } else {
            // const minLength = (fieldName === 'acctNum') ? JAPAN_POST_ACCOUNT_LENGTH : field.minlength
            // const maxLength = (fieldName === 'acctNum') ? JAPAN_POST_ACCOUNT_LENGTH : field.maxLength
            errorMessage = getFieldError(fieldValue, field)
            isValid = isEmpty(errorMessage)
        }
        if (isValid) {
            delete errors[[fieldName]]
        }
    }
    return errorMessage
}

function getFieldError (fieldValue, field, minLength, maxLength) {
    let key
    let errorMessage = ''

    if (field.allowSpace === false && containsWhiteSpace(fieldValue)) {
        key = field.fieldName + '.spaceError'
    } else if (field.allowSpace === true && startsOrEndsWithWhiteSpace(fieldValue)) {
        key = field.fieldName + '.spaceError'
    } else if (field.fieldType === 'numeric' && !isEmpty(fieldValue) && !isNumericValue(fieldValue)) {
        key = field.fieldName + '.invalid'
    } else if (field.fieldType === 'alphanumeric' && !isEmpty(fieldValue) && !isAlphaNumericValue(fieldValue)) {
        key = field.fieldName + '.invalid'
    } else if (!isEmpty(fieldValue) && minLength && fieldValue.length < minLength) {
        key = field.fieldName + '.lengthError'
    } else if (!isEmpty(fieldValue) && maxLength && fieldValue.length > maxLength) {
        key = field.fieldName + '.lengthError'
    }
    if (!isEmpty(key)) {
        errorMessage = errorMessages[key]
    }

    return errorMessage
}

export function validateDate (fieldArray, values, errors) {
    if (fieldArray && fieldArray.length > 0) {
        fieldArray.forEach(fieldName => {
            if (isEmpty(values[fieldName])) {
                errors = { ...errors, [fieldName]: errorMessages[fieldName] }
            }
        })
    }
    return errors
}

export function handleAPIErrors (responseData, errors) {
    const errorFields = Object.keys(responseData)
    let field
    const fieldNames = []
    for (let i = 0; i < requestFieldsArray.length; i++) {
        field = requestFieldsArray[i]
        fieldNames[i] = field.fieldName
    }

    errorFields.forEach((field) => {
        if (fieldNames.indexOf(field) > -1) {
            const key = field + '.kanaError'
            errors = { ...errors, [field]: errorMessages[key] }
        }
    }
    )
    const fieldId = errorFields[0]
    document.getElementById(fieldId).focus()
    return errors
}

export function handleAPIException (responseData, errors) {
    const errorReason = responseData.reason
    for (const field of requestFieldsArray) {
        if (errorReason.indexOf(field.fieldName) > -1) {
            errors = { ...errors, [field.fieldName]: errorMessages[field.fieldName + '.invalid'] }
            document.getElementById(field.fieldName).focus()
            break
        }
    }
    return errors
}

function isNumericValue (value) {
    return value.match(REGEX_NUMBERIC)
}

function isAlphaNumericValue (value) {
    return value.match(REGEX_ALPHA_NUMBERIC)
}

function containsWhiteSpace (value) {
    return /\s/.test(value)
}

function startsOrEndsWithWhiteSpace (value) {
    return /^\s|\s$/.test(value)
}
